import { CloseIcon } from "../../icons";
import { useLockBodyScroll } from "../../utils/hooks";

const Modal = ({ title = "", children, onClose,modalClass,modalBodyClass }) => {
    useLockBodyScroll();

    return (
        <>
            <div className="fixed top-0 left-0 z-[999] h-full w-full  py-3 pt-12 overflow-y-auto ">
                <div
                    className="modal-overlay w-full h-full fixed left-0 top-0 right-0 bottom-0  bg-[rgba(0,0,0,0.5)]"
                    onClick={onClose}
                ></div>

                <div className={`modal mx-auto w-full relative z-[99] ${modalClass}`}>
                    <div className="mx-4 z-1">
                        <span
                            className="cursor-pointer absolute right-[18px] -top-9"
                            onClick={onClose}
                        >
                            <CloseIcon />
                        </span>
                        {/* Modal Body */}
                        <div className={`modal-body bg-light-500 ${modalBodyClass}`}>{children}</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Modal;
